module.exports = " <a class=to-top v-on:click=top> <i class=\"fa fa-hand-o-up fa-2x\"></i> </a> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top.vue
 ** module id = 74
 ** module chunks = 0
 **/